export default {
  index: [
    {
      path: '/etransfer',
      component: resolve => require(['./etransferIndex.vue'], resolve),
    }
  ]
}



// WEBPACK FOOTER //
// ./src/view/etransfer/_router.js